import React from 'react';
import PropTypes from 'prop-types';

const NavItem = ({ children, link }) => (
  <li className={`nav__item ${window.location.pathname.includes(`admin${link}`) ? 'nav__item-active' : ''}`} role="presentation">
    {children}
  </li>
)

NavItem.propTypes = {
  link: PropTypes.string,
  children: PropTypes.any,
};

export default NavItem;
